<template>
   <scroll-pages></scroll-pages>
</template>

<script>
import {LOCAL_HOST,SCHEDULER_URL} from '@/constants/general_constants';
// import FooterBottomDown from '@/components/ThemeMegazine/pages/partialsCommon/FooterBottomDown';
import ScrollPages from '@/components/ThemeMegazine/pages/partialsCommon/ScrollPages';
 export default {
     
    name: 'Footer',
    components:{
        ScrollPages
    //    FooterBottomDown
    },
    data(){
        return{
            LOCAL_HOST:LOCAL_HOST,
            SCHEDULER_URL:SCHEDULER_URL
        }
    },

    created() {
        
        //this.loadExternalScript(LOCAL_HOST+"/ThemeMegazine/js/jquery.min.js"),
        //this.loadExternalScript(LOCAL_HOST+"/ThemeMegazine/js/jquery.easing.1.3.js"),
        //this.loadExternalScript(LOCAL_HOST+"/ThemeMegazine/js/bootstrap.min.js"),
        this.loadExternalScript(LOCAL_HOST+"/ThemeMegazine/js/jquery.waypoints.min.js"),
        this.loadExternalScript(LOCAL_HOST+"/ThemeMegazine/js/jquery.flexslider-min.js"),
        this.loadExternalScript(LOCAL_HOST+"/ThemeMegazine/js/jquery.magnific-popup.min.js"),
        //this.loadExternalScript(LOCAL_HOST+"/ThemeMegazine/js/magnific-popup-options.js"),
        //this.loadExternalScript(LOCAL_HOST+"/ThemeMegazine/js/owl.carousel.min.js"),
        //this.loadExternalScript(LOCAL_HOST+"/ThemeMegazine/js/sticky-kit.min.js"),
        this.loadExternalScript(LOCAL_HOST+"/ThemeMegazine/js/main.js"),
        this.loadExternalScript(SCHEDULER_URL)
        
        window.$ = window.jQuery = require('jquery')
        
    },
    methods:{
        loadExternalScript(path_to_file){
            //console.log('calling create scr wow');
            const plugin = document.createElement("script");
            plugin.setAttribute(
            "src",
            path_to_file
            );
            plugin.async = true;
            document.body.appendChild(plugin);
        }
    }

    
};
</script>
<style>
.btn {
    margin: 0rem !important;
}
.btn-primary {
    /* background: #F75940 !important; */
    background: #AB1D07 !important;  
    color: #fff !important;
    border: 2px solid #AB1D07 !important;
}
:focus, .btn-primary:focus, .srch-box:focus {  
  	outline: 2px dotted #e9f8ff !important;
	border: 2px solid #1d1d1d !important;
    outline-offset: -3px !important;
       
    /* border: 2px solid #1d1d1d !important;
    outline-offset: -3px !important; */
    }
    
/*scroll bar common to all pages on menu start*/
#colorlib-aside:hover{
    overflow-y: auto !important;
    
}
#colorlib-aside:focus-within{
    overflow-y: auto !important;
    
}	
#colorlib-aside::-webkit-scrollbar-track{
    -webkit-box-shadow: inset 0 0 0px rgb(146 146 146 / 23%);
    border-radius: 10px;
    background-color: #fcfcfc;
}		
#colorlib-aside::-webkit-scrollbar{
    width: 5px;
    background-color: #fff;
}
#colorlib-aside::-webkit-scrollbar-thumb{
    border-radius: 6px;
    -webkit-box-shadow: inset 0px 0 2px rgb(112, 110, 110);
    background-color: #FFF;
}
/*scroll bar on menu */	
a:hover{
    text-decoration: underline !important;
}
#colorlib-aside a:hover{
    text-decoration: none !important;
}
</style>